export const getComputedStyle = (element: any) => {
    var maxHeight = 0;
    var childElements = element?.children;

    if (childElements) {
        for (var i = 0; i < childElements?.length; i++) {
            var computedStyles = window.getComputedStyle(childElements[i]);

            var h = parseFloat(computedStyles.height);
            var mt = parseFloat(computedStyles.marginTop);
            var mb = parseFloat(computedStyles.marginBottom);
            var pt = parseFloat(computedStyles.paddingTop);
            var pb = parseFloat(computedStyles.paddingBottom);

            var totalHeight = (isNaN(h) ? 0 : h) +
                (isNaN(mt) ? 0 : mt) +
                (isNaN(mb) ? 0 : mb) +
                (isNaN(pt) ? 0 : pt) +
                (isNaN(pb) ? 0 : pb);

            maxHeight = Math.max(maxHeight, totalHeight);
        }
    }

    return maxHeight;
}
